import { intercomImportTemplate } from '@/features/Setting/Integrations/providers/Intercom/intercomImportTemplate';
import type { ImportRuleT } from '@/features/Setting/Integrations/providers/types';
import { defaultAxios } from '@/services/index';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

import { processImportRuleParam } from '../util';

const intercomService = {
  async createIntercomInfo(code: string, workspaceAlias: string) {
    const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/intercom/authenticated`,
        { code },
      );
      return res.data;
  },
  async getIntercomInfo(alias: string) {
    const res = await defaultAxios.get(`/workspaces/${alias}/intercom/`);
      return res.data;
  },
  async importWorkspaceFeedback(
    workspaceAlias: string,
    startDate: string,
    endDate: string,
  ) {
    const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/intercom/import`,
        {
          start_date: startDate,
          end_date: endDate,
        },
      );
      return res.data;
  },
  async deleteIntercomInfo(alias: string) {
    const res = await defaultAxios.delete(`/intercom/${alias}`);
      return res.data;
  },
  async updateIntercomImportOption(importRule: ImportRuleT) {
    const wa = getCurrWorkspaceAlias();
      const processedImportRule = processImportRuleParam(
        importRule,
        intercomImportTemplate,
      );
      const res = await defaultAxios.patch(
        `/workspaces/${wa}/intercom/trigger`,
        processedImportRule,
      );
      return res.data;
  },
};

export default intercomService;
